import styled from 'styled-components';

const ImpersonationRow = styled.div`
  cursor: pointer;
  font-size: ${props => props.fontSize ? props.fontSize: '1em'};
`;

export {
  ImpersonationRow
};